module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Light.5dc359c.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Light.eot
// module id = j8Kf
// module chunks = 1